import { useEffect, useMemo } from 'react';
import useDesign from 'packages/pages/design/hooks/useDesign';
import useCommonRenditionProfiles from 'packages/hooks/useRenditionProfiles';

const useRenditionProfiles = () => {
    const { creativeType, template } = useDesign();
    const renditionProfilesState = useCommonRenditionProfiles({ creativeType });
    const { renditionProfiles, selectedProfile, setSelectedProfile } = renditionProfilesState;

    const filteredRenditionProfiles = useMemo(() => {
        const configuredExportConfigurationIds = template?.exportConfigurationIds ?? [];

        if (!configuredExportConfigurationIds.length) {
            return renditionProfiles;
        }

        const allowedExportConfigurationIds = new Set(configuredExportConfigurationIds);
        const allowedRenditionProfiles = renditionProfiles.filter(({ id }) => allowedExportConfigurationIds.has(id));

        return allowedRenditionProfiles.length ? allowedRenditionProfiles : renditionProfiles;
    }, [renditionProfiles, template?.exportConfigurationIds]);

    const filteredSelectedProfile =
        filteredRenditionProfiles.find(({ id }) => id === selectedProfile?.id) || filteredRenditionProfiles[0] || null;

    useEffect(() => {
        if (selectedProfile?.id !== filteredSelectedProfile?.id) {
            setSelectedProfile(filteredSelectedProfile);
        }
    }, [filteredSelectedProfile, selectedProfile?.id, setSelectedProfile]);

    return {
        ...renditionProfilesState,
        renditionProfiles: filteredRenditionProfiles,
        selectedProfile: filteredSelectedProfile,
    };
};

export default useRenditionProfiles;
